export const THERAPY_INDICATION_STATUS = [
  { value: 'REQUESTED', label: 'therapyIndication.status.requested', color: 'primary.main' },
  { value: 'FINISHED', label: 'therapyIndication.status.finished', color: 'success.main' },
  { value: 'DELETED', label: 'therapyIndication.status.deleted', color: 'error.main' },
  { value: 'WAIT', label: 'therapyIndication.status.wait', color: 'warning.main' },
];
